// 数据埋点 api
import axios from 'axios'
import qs from 'qs'
import MD5 from 'js-md5'

const service = axios.create({
  baseURL: 'https://api.crm.yes-go.cn/', // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// 响应拦截器 设置头部
service.interceptors.request.use(
  config => {
    var serial = Date.parse(new Date()).toString() / 1000
    var secret = 'YTv2frev0Fc8El8cmaRqFpUMghwep3gv'
    var appkey = 'wQr1dc5b4i'
    var sign = MD5(secret + appkey + serial)

    // 判断缓存中是否有token, 没有退出登录
    config.headers = {
      appkey: appkey,
      serial: serial,
      sign: sign
    }

    // 如果是put请求,加入请求头
    if (config.method === 'put') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      config.transformRequest = [function(data) {
        return qs.stringify(data)
      }]
    }

    // 拦截post请求
    if (config.method === 'post') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      config.transformRequest = [function(data) {
        return qs.stringify(data)
      }]
    }
    return config
  },
  error => {
    // do something with request error
    console.log('error', error) // for debug
    return Promise.reject(error)
  }
)

export default service
